var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"GroupBulkShelvesContent"},[_c('GroupBulkShelvesContent',{ref:"GroupBulkShelvesContentRef",on:{"visibleChange":_vm.visibleChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }